import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';


@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})
export class SidemenuComponent implements OnInit {
  itemSelected:any;
  @Input() items: any;
  @Input() icons: any;
  @Output() changeContent = new EventEmitter<any>();
  ngOnInit(): void {

  }

  ngOnChanges() {
    
    if(this.items) {
      this.itemSelected = sessionStorage.getItem('currentPage') ? JSON.parse(sessionStorage.getItem('currentPage') || '{}') : this.items[0];
    }
  }
  // emit verso il contenitore padre al click sul menu
  loadContent(value: Object, index:any) {
    sessionStorage.setItem('currentPage',JSON.stringify(value));
    this.changeContent.emit(value);
    this.itemSelected = value;
  }

  isActive(item:any) {
    return this.itemSelected.id === item.id;
  };
}
